import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';

// Se muestra como fallback del Switch de containers/Full: cualquier ruta que no
// matchee cae aca. Antes esta pagina existia pero era inalcanzable (el Switch
// terminaba en un Redirect a /dashboard, que se tragaba las URLs invalidas).
class Page404 extends Component {
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <div className="clearfix">
                <h1 className="float-left display-3 mr-4">404</h1>
                <h4 className="pt-3">Página no encontrada</h4>
                <p className="text-muted float-left">
                  La dirección a la que quisiste entrar no existe o fue dada de baja.
                </p>
              </div>
              <Link to="/dashboard">
                <Button color="info">Volver al inicio</Button>
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Page404;



// WEBPACK FOOTER //
// ./src/views/Pages/Page404/Page404.js